// extracted by mini-css-extract-plugin
export default {"searchCl":"SearchInput_searchCl__An2oE"};